import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const SubmodalityForm = ({ subModalityId, initialData, onSuccess }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [submodalityName, setSubmodalityName] = useState('');
  const [selectedModality, setSelectedModality] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [submodalityID, setSubmodalityID] = useState('');
  const [modalities, setModalities] = useState([]);
  const [subModClass, setSubMobClass] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Fetch modalities for dropdown
  useEffect(() => {
    const fetchModalities = async () => {
      try {
        const res = await fetch(`${baseUrl}/getModalities`, { method: 'GET' });
        const data = await res.json();

        if (data.status) {
          setModalities(data.data || []);
        } else {
          setError('Failed to load modalities');
        }
      } catch (err) {
        setError('Error fetching modalities');
      }
    };

    fetchModalities();
  }, [baseUrl]);

  useEffect(() => {
    const fetchSubModClass = async () => {
      try {
        const res = await fetch(`${baseUrl}/getSubModClass`, { method: 'GET' });
        const data = await res.json();

        if (data.status) {
          setSubMobClass(data.data || []);
        } else {
          setError('Failed to load classifications');
        }
      } catch (err) {
        setError('Error fetching classifications');
      }
    };

    fetchSubModClass();
  }, [baseUrl]);

  // console.log("check anand", initialData);
  // return;

  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData) {
      if (initialData.sub_mod_name) {
        setSubmodalityName(initialData.sub_mod_name);
      }
      if (initialData.mod_id) {
        setSelectedModality(initialData.mod_id);
      }
      if (initialData.service_id) {
        setSubmodalityID(initialData.service_id);
      }
      if (initialData.sub_mod_class) {
        setSelectedClass(initialData.sub_mod_class);
      }
      
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!submodalityName.trim()) {
      setError('Submodality name is required');
      return;
    }
    if (!selectedModality) {
      setError('Please select a modality');
      return;
    }
    if (!submodalityID) {
      setError('Service ID is required');
      return;
    }if (!selectedClass.trim()) {
      setError('Please select sub modality type');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {};

      if (subModalityId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateSubModalityById/${subModalityId}`;
        body = {
          mod_id: selectedModality,   // ✅ backend expects mod_name as reference
          service_id: submodalityID,
          sub_mod_name: submodalityName,
          sub_mod_class: selectedClass,
        };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createSubModality`;
        body = {
          mod_id: selectedModality,
          service_id: submodalityID,
          sub_mod_name: submodalityName,
          sub_mod_class: selectedClass,
        };
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(subModalityId ? 'Sub modality updated successfully' : 'Sub modality created successfully');
        if (onSuccess) onSuccess();
        // navigate('/submodality');
      } else {
        setError(data.message || `Failed to ${subModalityId ? 'update' : 'create'} Submodality`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">
        {subModalityId ? 'Edit Sub Modality' : 'Add Sub Modality'}
      </h2>

      <div className="form-grid">

        {/* ✅ Dropdown for modalities */}
        <div className="form-floating">
          <select
            className="form-select"
            id="modality"
            value={selectedModality}
            onChange={(e) => setSelectedModality(e.target.value)}
            disabled={loading}
          >
            <option value=""></option> {/* 👈 must be empty */}
            {modalities.map((mod) => (
              <option key={mod.id} value={mod.id}>
                {mod.mod_name}
              </option>
            ))}
          </select>
          <label htmlFor="modality">Select Modality</label>
        </div>

        {/* ✅ Input for sub modality ID */}
        <div className="form-floating">
          <input
            type="int"
            className="form-control"
            id="submodalityID"
            placeholder=" "
            autoComplete="off"
            value={submodalityID}
            onChange={(e) => setSubmodalityID(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="submodalityID">Service ID</label>
        </div>

        {/* ✅ Input for sub modality name */}
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="submodalityName"
            placeholder=" "
            autoComplete="off"
            value={submodalityName}
            onChange={(e) => setSubmodalityName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="submodalityName">Sub Modality Name</label>
        </div>
      </div>

      {/* ✅ Dropdown for Sub Modality Class */}
        <div className="form-floating">
          <select
            className="form-select"
            id="submodalityclass"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            disabled={loading}
          >
            <option value=""></option> {/* 👈 must be empty */}
            {subModClass.map((mod) => (
              <option key={mod.id} value={mod.id}>
                {mod.sub_mod_class}
              </option>
            ))}
          </select>
          <label htmlFor="submodalityclass">Select Class Type</label>
        </div>

      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}

      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: '15px' }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};

export default SubmodalityForm;